export const tickerActionTypes = {
  TICKER_LOADING: "TICKER_LOADING",
  TICKER_SUCCESS: "TICKER_SUCCESS",
  TICKER_ERROR: "TICKER_ERROR",
  TICKER_RESET: "TICKER_RESET",
};
